import { atom } from 'recoil';
import { IWidget } from '../../components/OnlinePanel/Widgets/types';

export const usedWidgets = atom<IWidget[]>({
  key: 'usedWidgets',
  default: [],
});
